var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// node_modules/@substrate-system/web-component/dist/attributes.js
var __defProp2 = Object.defineProperty;
var __name2 = /* @__PURE__ */ __name((target, value) => __defProp2(target, "name", { value, configurable: true }), "__name");
function toAttributes(attrs) {
  return Object.keys(attrs).reduce((acc, k) => {
    const value = attrs[k];
    if (!value) return acc;
    if (typeof value === "boolean") {
      if (value) return (acc + ` ${k}`).trim();
      return acc;
    }
    if (Array.isArray(value)) {
      return acc + ` ${k}="${value.join(" ")}"`;
    }
    return (acc + ` ${k}="${value}"`).trim();
  }, "");
}
__name(toAttributes, "toAttributes");
__name2(toAttributes, "toAttributes");

// src/html.ts
function CopyButton(options) {
  let classes;
  let hint;
  if (Array.isArray(options)) {
    classes = options;
  } else if (options) {
    classes = options.classes;
    hint = options.hint;
  }
  const classString = (classes || []).concat(["copy-button"]).filter(Boolean).join(" ");
  let hintHtml = "";
  if (hint !== void 0 && hint !== false) {
    const hintText = hint === true || hint === "" ? "Copied" : hint;
    hintHtml = `<span popover="manual" class="copy-hint" role="status" aria-live="polite">${hintText}</span>`;
  }
  return `<button aria-label="Copy" ${classString ? `class="${classString}"` : ""}>
        ${CopySvg()}
        <span class="visually-hidden">Copy</span>
    </button>${hintHtml}`;
}
__name(CopyButton, "CopyButton");
CopyButton.outerHTML = (options, attrs = {}) => {
  const attributes = toAttributes(attrs);
  return `<copy-button${attributes.length ? ` ${attributes}` : ""}>
        ${CopyButton(options)}
    </copy-button>`;
};
function CopySvg() {
  return `<span class="copy-wrapper">
        <svg
            aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1"
            focusable="false"
            width="16" class="copy-svg"
        >
            <path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"></path><path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path>
        </svg>
    </span>`;
}
__name(CopySvg, "CopySvg");
function SuccessSvg() {
  return `<span class="success-wrapper">
        <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1"
            width="16"
            class="success-svg"
            focusable="false"
        >
            <path d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"></path>
        </svg>
    </span>`;
}
__name(SuccessSvg, "SuccessSvg");
export {
  CopyButton,
  CopySvg,
  SuccessSvg
};
